module.exports = __webpack_public_path__ + "img/advantage2Red.6f57e4bb.png";